import { ProductOption, type ProductOptionValueTypes } from "../ProductOption.js";

const truthMap: {
	[Option in ProductOption]: (option: ProductOptionValueTypes[Option] | undefined) => boolean;
} = {
	[ProductOption.CreamColor]: (value) => value !== undefined,
	[ProductOption.CustomerRequirement]: (value) => value !== undefined,
	[ProductOption.ExtraFruit]: (value) => value === true,
	[ProductOption.Figurines]: (value) => (value?.length ?? 0) > 0,
	[ProductOption.Filling]: (value) => value !== undefined,
	[ProductOption.GlutenFreeVariant]: (value) => value === true,
	[ProductOption.Inscription]: (value) => value !== undefined,
	[ProductOption.Labels]: (value) => (value?.length ?? 0) > 0,
	[ProductOption.LactoseFreeVariant]: (value) => value === true,
	[ProductOption.LyingPhoto]: (value) => value !== undefined,
	[ProductOption.Macaroons]: (value) => value !== undefined,
	[ProductOption.Meringues]: (value) => value === true,
	[ProductOption.Numbers]: (value) => (value?.length ?? 0) > 0,
	[ProductOption.StandingPhotos]: (value) => (value?.length ?? 0) > 0,
};

export function isProductOptionUsed<Option extends ProductOption>(
	option: Option,
	value: ProductOptionValueTypes[Option],
): value is Exclude<ProductOptionValueTypes[Option], undefined> {
	return truthMap[option](value);
}
